import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../AuthContext";
import { privateAxios } from "../utils/axios";
import usePermissions from "../hooks/usePermissions";
import toast from "react-hot-toast";
import PurchaseReportModal from "../components/PurchaseReportModal";

function GenerateReport() {
  const [suppliers, setSuppliers] = useState([]);
  const [purchaseReportData, setPurchaseReportData] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);



  // Purchase Report Filters
  const [purchaseFilters, setPurchaseFilters] = useState({
    supplier_name: "",
    productId: "",
    startDate: "",
    endDate: "",
  });


  const authContext = useContext(AuthContext);
  const { canRead } = usePermissions();


  const canAccessPurchaseReport = canRead("purchase-report");


  useEffect(() => {
    fetchSuppliersData();
  }, []);

  // Fetch suppliers data
  const fetchSuppliersData = () => {
    privateAxios
      .get(`/suppliers/all`)
      .then((response) => {
        if (response.data.success) {
          setSuppliers(response.data.data);
        }
      })
      .catch((err) => console.log(err));
  };


  // Generate Purchase Report
  const handleGeneratePurchaseReport = async () => {
    setIsGeneratingReport(true);
    try {
      const queryParams = new URLSearchParams();
      if (purchaseFilters.supplier_name) {
        queryParams.append("supplier_name", purchaseFilters.supplier_name);
      }
      if (purchaseFilters.productId) {
        queryParams.append("productId", purchaseFilters.productId);
      }
      if (purchaseFilters.startDate) {
        queryParams.append("startDate", purchaseFilters.startDate);
      }
      if (purchaseFilters.endDate) {
        queryParams.append("endDate", purchaseFilters.endDate);
      }

      const response = await privateAxios.get(
        `/purchase/generate-report?${queryParams}`
      );
      if (response.data.success) {
        setPurchaseReportData(response.data.data);
        toast.success("Purchase report generated successfully");
      }
    } catch (error) {
      console.error("Error generating purchase report:", error);
      toast.error("Failed to generate purchase report");
    } finally {
      setIsGeneratingReport(false);
    }
  };



  return (
    <div className="col-span-12 lg:col-span-10 flex justify-center">
      <div className="flex flex-col gap-5 w-11/12">
        {/* Page Header */}
        <div className="bg-white rounded-xl border border-gray-200 p-6 w-full mt-6 mb-8">
          <div className="flex justify-between items-start">
            <div>
              <span className="font-bold text-xl text-gray-900">
               Purchase Report
              </span>
              <div className="text-gray-500 text-sm mt-1">
             Get key insights and visualizations from the inventory summary
              </div>
            </div>
          </div>
        </div>


        {/* Purchase Report Modal */}
        {/* {showPurchaseModal && canAccessPurchaseReport && ( */}
          <PurchaseReportModal
            filters={purchaseFilters}
            setFilters={setPurchaseFilters}
            reportData={purchaseReportData}
            isGenerating={isGeneratingReport}
            onGenerate={handleGeneratePurchaseReport}
            suppliers={suppliers}
          />
        {/* // )}
    */}
      </div>
    </div>
  );
}

export default GenerateReport;
